import Vue from "vue";
import Vuex from "vuex";
import JwtService from "./jwt.service";
import Auth from "./common/firebase.auth";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    isAuthenticated: JwtService.getToken(),
    userRoles: null,
    userInfo: null,
    school: null,
    error: null,
    toast: null,
    showMenu: true,
    users: [],
    testAccounts: [
      "peerasak@ookbee.com",
      "ow.mock@rathakun.com",
      "mai.mock@rathakun.com",
      "rtk1@rtk.com",
      "rtk2@rtk.com",
      "rtk3@rtk.com",
      "rtk4@rtk.com",
      "rtk5@rtk.com",
      "konmai@konmai.com",
      "konmai2@konmai.com"
    ],
    menu: []
  },
  getters: {
    environment() {
      return process.env.NODE_ENV;
    },
    testAccounts(state) {
      return state.testAccounts;
    },
    isSuperAdmin(state) {
      return state.testAccounts.includes(state.userInfo.email);
    },
    currentUser(state) {
      return state.user;
    },
    currentUserInfo(state) {
      return state.userInfo;
    },
    schoolUsers(state) {
      return state.users;
    },
    currentRoles(state) {
      return state.userRoles;
    },
    currentSchool(state) {
      if (state.school) {
        return state.school;
      }
      return null;
    },
    errorMessage(state) {
      if (state.error) {
        return state.error.message;
      }
      return null;
    },
    toastMessage(state) {
      if (state.toast) {
        return state.toast;
      }
      return null;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    mainMenu(state) {
      return state.menu;
    },
    showMenu(state) {
      return state.showMenu;
    }
  },
  actions: {
    login({ commit }, credentials) {
      commit("setAuth", credentials);
    },
    saveUserInfo({ commit }, userInfo) {
      commit("setUserInfo", userInfo);
    },
    logout({ commit }) {
      commit("clearAuth");
      commit("setShowMenu", false);
    },
    setUserRoles({ commit }, roles) {
      commit("setUserRoles", roles);
    },
    setError({ commit }, error) {
      commit("setError", error);
    },
    setErrorMessage({ commit }, message) {
      commit("setErrorMessage", message);
    },
    setToast({ commit }, toast) {
      commit("setToast", toast);
    },
    setRawError({ commit }, error) {
      commit("setRawError", error);
    },
    setSchool({ commit }, school) {
      commit("setSchool", school);
    },
    toggleSidebar({ commit }) {
      commit("toggleSidebar");
    },
    showSidebar({ commit }) {
      commit("showSidebar");
    },
    clearError({ commit }) {
      commit("clearError");
    },
    clearToast({ commit }) {
      commit("setToast", null);
    },
    toggleMenu({ commit }, data) {
      commit("setShowMenu", data);
    },
    updateSchoolUsers({ commit }, users) {
      commit("setSchoolUsers", users);
    },
    checkAuth({ commit }) {
      let userInfo = JwtService.getUserProfile();
      if (userInfo) {
        commit("setUserInfo", userInfo);
      }
    }
  },
  mutations: {
    setAuth(state) {
      state.isAuthenticated = true;
      state.user = Auth.currentUser;
    },
    setUserInfo(state, userInfo) {
      state.user = Auth.currentUser;
      state.school = userInfo.school;
      state.userInfo = userInfo;

      JwtService.saveUserProfile(userInfo);
    },
    setSchoolUsers(state, users) {
      state.users = users;
    },
    setUserRoles(state, roles) {
      state.userRoles = roles;
    },
    setShowMenu(state, data) {
      state.showMenu = data;
    },
    setSchool(state, data) {
      state.isAuthenticated = true;
      state.school = data;

      JwtService.saveSchool(data);
    },
    setError(state, data) {
      if (!data.response) return;
      state.error = { message: data.response.data.error };
    },
    setErrorMessage(state, message) {
      state.error = { message: message };
    },
    setToast(state, data) {
      state.toast = data;
    },
    setRawError(state, error) {
      state.error = error;
    },
    async clearAuth(state) {
      state.showMenu = false;
      await Auth.signOut();
      state.isAuthenticated = false;
      state.user = null;
      state.school = null;
      JwtService.destroyToken();
    },
    clearError(state) {
      state.error = null;
    }
  }
});
